import { render, staticRenderFns } from "./orgType.vue?vue&type=template&id=d9836be4&"
import script from "./orgType.vue?vue&type=script&lang=js&"
export * from "./orgType.vue?vue&type=script&lang=js&"
import style0 from "./orgType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports